<template>
  <div class="footer">
    <div class="footer__wrapper">
      <div class="footer__logo"></div>
      <div class="footer__contact">info@montebit.io</div>
      <div class="footer__texts">Siguenos:</div>
      <ul class="footer__social">
        <li
          :class="`footer__net ${net.name}`"
          v-for="net in social"
          :key="net.id"
        >
          <a class="footer__net-link" :href="net.url" target="_blank">{{net.name}}</a>
        </li>
      </ul>
      <ul class="footer__list">
        <li v-for="item in items" :key="item.id">
          <a class="footer__item" :href="item.url"> {{ item.name }}</a>
        </li>
      </ul>
    </div>
    <div class="footer__fade"></div>
  </div>
</template>
<script>
export default {
  name: "Footer",

  props: {
    logo: {
      type: String,
    },
    items: {
      type: Array,
    },
    social: {
      type: Array,
    },
  },
};
</script>